import React from "react";

export default function Footer() {
  return (
    <footer style={{ background: "#f1f1f1", padding: "10px", textAlign: "center" }}>
      <small>© 2025 Tutor/Mentor Network Template — MIT License</small>
    </footer>
  );
}
